import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import SupplierServices from "../../../Services/QRCodeServices/SupplierServices/SupplierServices";

const validationSchema = Yup.object({
  supplierName: Yup.string().required("Supplier name is required"),
});

const SupplierAddEdit = ({ isOpen, toggle, supplierData, onSuccess }) => {
  const isEditMode = !!supplierData;

  const formik = useFormik({
    initialValues: {
      id: supplierData?.id || 0,
      supplierName: supplierData?.supplierName || "",
      location: supplierData?.location || "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        if (isEditMode) {
          await SupplierServices.update(supplierData.id, values);
          toast.success("Supplier updated successfully");
        } else {
          await SupplierServices.create(values);
          toast.success("Supplier created successfully");
        }
        onSuccess();
        toggle();
      } catch (error) {
        toast.error(
          error?.response?.data ||
            `Failed to ${isEditMode ? "update" : "create"} supplier`
        );
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {isEditMode ? "Edit Supplier" : "Add New Supplier"}
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <FormGroup>
            <Label for="supplierName">Supplier Name</Label>
            <Input
              type="text"
              name="supplierName"
              id="supplierName"
              value={formik.values.supplierName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={
                formik.touched.supplierName && !!formik.errors.supplierName
              }
            />
            {formik.touched.supplierName && formik.errors.supplierName && (
              <div className="text-danger">{formik.errors.supplierName}</div>
            )}
          </FormGroup>

          <FormGroup>
            <Label for="location">Location</Label>
            <Input
              type="text"
              name="location"
              id="location"
              value={formik.values.location}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              invalid={formik.touched.location && !!formik.errors.location}
            />
            {formik.touched.location && formik.errors.location && (
              <div className="text-danger">{formik.errors.location}</div>
            )}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            onClick={toggle}
            disabled={formik.isSubmitting}
          >
            Cancel
          </Button>
          <Button color="success" type="submit" disabled={formik.isSubmitting}>
            {formik.isSubmitting
              ? "Saving..."
              : isEditMode
              ? "Update"
              : "Create"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default SupplierAddEdit;
